import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { translate as trans } from "../Trans/Trans";

const bodyStyles = {
  fontSize: "sm",
  a: {
    color: "blue.500",
  },
};

const PostEditorPublishNowConfirmModal = ({ onClose, onConfirm }) => (
  <Modal autoFocus={false} returnFocusOnClose={false} isOpen onClose={onClose}>
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>
        {trans("post_editor.publish_now_confirm.title")}
      </ModalHeader>
      <ModalBody sx={bodyStyles}>
        <Box
          lineHeight="inherit"
          dangerouslySetInnerHTML={{
            __html: trans("post_editor.publish_now_confirm.message"),
          }}
        />
      </ModalBody>
      <ModalFooter>
        <ButtonGroup size="sm" spacing="3">
          <Button onClick={onClose} variant="secondary">
            {trans("generic.cancel")}
          </Button>
          <Button variant="solid" onClick={onConfirm}>
            {trans("post_editor.publish_now_confirm.confirm")}
          </Button>
        </ButtonGroup>
      </ModalFooter>
      <ModalCloseButton />
    </ModalContent>
  </Modal>
);

PostEditorPublishNowConfirmModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

PostEditorPublishNowConfirmModal.defaultProps = {};

export default PostEditorPublishNowConfirmModal;
